import {
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
    ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { bdsGridModeType } from '@bds/components';

import { CommunicationService } from '@bds/core';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { CarIdTransformService } from '@bds/helpers';

import { RtUnitTrainSummaryGridService } from '@bds/railtrac';

import { FastracColsService } from '@bds/services';

import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { Subject } from 'rxjs';

import { PageService } from '@bds/core';
import { RtvUnitTrainTrip } from '@bds/railtrac-models';

@Component({
    selector: 'app-unit-train-summary-screen',
    templateUrl: './unit-train-summary-screen.component.html',
    styleUrl: './unit-train-summary-screen.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class UnitTrainSummaryScreenComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild('dxGridWrapper') fastracGridComponent: FastracDxGridWrapperComponent;

    public gridSource: DataSource;
    public selectedRowKeys: string[] = [];
    public gridId = 141;
    public gridMode: bdsGridModeType = 'multiple';
    public gridStore: ODataStore;
    public unitTrainList: RtvUnitTrainTrip[] = [];

    private ngUnsubscribe$: Subject<boolean> = new Subject<boolean>();

    get grid() {
        return this.fastracGridComponent?.grid;
    }

    constructor(
        public unitTrainSummaryGridService: RtUnitTrainSummaryGridService,
        public router: Router,
        public route: ActivatedRoute,
        pageService: PageService,
        public gridColumnService: FastracColsService,
        public carIdTransformService: CarIdTransformService,
        public communicationService: CommunicationService,
        private cdr: ChangeDetectorRef,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);

        pageService.setHeader('UNIT TRAIN SUMMARY');

        this.gridSource = this.unitTrainSummaryGridService.getODataStore();
    }

    onSelectionChanged(unitTrainList: RtvUnitTrainTrip[]): void {
        if (this.grid?.instance) {
            this.unitTrainList = unitTrainList;
        }
    }

    ngOnInit() {
        super.ngOnInit();
        setTimeout(() => {
            this.grid?.instance.repaint();
        }, 100);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.ngUnsubscribe$.next(true);
        this.ngUnsubscribe$.unsubscribe();
    }

    refreshGrid(): void {
        void this.grid.instance.refresh();
    }

    onGridFastracIdChanged($event: number): void {
        super.onGridFastracIdChanged($event);
        void this.grid.instance.refresh();
    }
}
